import { Badge, Flex, Text } from '@chakra-ui/react';

import type { FunnelStageType, InteractionCardType } from '../types';
import InteractionCard from './InteractionCard';

type Props = {
  stage: FunnelStageType,
  interactions: InteractionCardType[],
};

const Column = ({ stage, interactions }: Props) => (
  <Flex
    direction="column"
    flex="1 0 320px"
    minW={320}
    minH={{ base: 400, md: '100%' }}
    bg="bg.muted"
    borderRadius="md"
    p={3}
  >
    <Flex alignItems="center" justifyContent="space-between" mb={3} flexShrink={0}>
      <Text fontWeight={600} color="fg.default" truncate>
        {stage.name}
      </Text>
      <Badge colorPalette="gray" variant="solid">
        {interactions.length}
      </Badge>
    </Flex>

    <Flex direction="column" gap={2} flex="1" minH={0} overflowY="auto">
      {interactions.length === 0 ? (
        <Text fontSize="sm" color="fg.muted" textAlign="center" py={6}>
          Nenhum atendimento
        </Text>
      ) : (
        interactions.map((interaction) => (
          <InteractionCard
            key={interaction.id}
            interaction={interaction}
          />
        ))
      )}
    </Flex>
  </Flex>
);

export default Column;
